import React, { useContext } from 'react';
import { MapContext } from '../../../../../contexts/MapContext';
import './MarkersPathWindow.scss';
import './Adaptations.scss';

const MarkersPathWindow = () => {
    const {
        markersPathStatus,
        setMarkersPathStatus,
        routeDataExtended,
        showDistancesUserStatus,
        setShowDistancesUserStatus,
    } = useContext(MapContext);

    // Only show the window if status is 'instruction' or 'displayed'
    const isVisible = markersPathStatus === 'instruction' || markersPathStatus === 'displayed';

    // Click handler for the close button
    const handleClose = () => {
        setMarkersPathStatus('idle');
        setShowDistancesUserStatus(false);
    };

    let content = null;
    if (markersPathStatus === 'instruction' && showDistancesUserStatus === true) {
        content = (
            <>
                <div className="close-btn" onClick={handleClose} aria-label="Close">
                    <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M1 1L13 13M13 1L1 13"
                            stroke="#333"
                            strokeWidth="2"
                            fill="none"
                            strokeLinecap="round"
                        />
                    </svg>
                </div>
                <div className="instruction-content">
                    <strong>CLICK</strong> AT ANY ELLINGTON ICON TO SET POINT A,
                    <br />
                    THEN <strong>CLICK</strong> AT ANY OTHER POINT
                    <br />
                    OF INTEREST TO SET POINT B
                </div>
            </>
        );
    } else if (markersPathStatus === 'displayed' && routeDataExtended) {
        content = (
            <div className="route-details-content">
                <div className="close-btn" onClick={handleClose} aria-label="Close">
                    <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M1 1L13 13M13 1L1 13"
                            stroke="#333"
                            strokeWidth="2"
                            fill="none"
                            strokeLinecap="round"
                        />
                    </svg>
                </div>
                <div className="route-header">
                    <strong>{(routeDataExtended.startName || 'Start').toUpperCase()}</strong>
                    <span>TO</span>
                    <strong>{(routeDataExtended.endName || 'End').toUpperCase()}</strong>
                </div>
                <div className="route-subheader">
                    IS APPROXIMATELY&nbsp;
                    <strong>{routeDataExtended.response.travel_time_min.toFixed(0)}</strong> min
                    | <strong>{routeDataExtended.response.distance_km.toFixed(0)}</strong> km
                </div>
                <div className="route-footer">
                    this info based on average distance and normal traffic condition
                </div>
            </div>
        );
    }

    return (
        <div className={`markers-path-window ${isVisible ? 'visible' : ''}`}>
            {content}
        </div>
    );
};

export default MarkersPathWindow;
